import { CONTENT_TEST_ARTIFACT_KEY_PREFIX } from '@inference.engine/widgets/web';
import { ROUTES } from '@/shared/config/routes';

/**
 * Maps a saved "dedicated-entity" artifact back to its source tool view.
 *
 * Artifacts minted from a standalone resource (Content Test, …) carry a
 * `${prefix}${entityId}` key, so the prefix tells us both the resource type and
 * — after slicing it off — the entity id. When we recognize the prefix we can
 * deep-link the Library card's "View" action straight to that resource's page.
 *
 * Returns null for artifacts with no standalone source (chat-flow widgets,
 * uploads, generic kinds); the card then omits the View action. New saveable
 * resources slot in as additional prefix branches here.
 */
export function resolveArtifactResourceRoute(artifactKey: string | null): string | null {
  if (!artifactKey) return null;

  if (artifactKey.startsWith(CONTENT_TEST_ARTIFACT_KEY_PREFIX)) {
    const id = artifactKey.slice(CONTENT_TEST_ARTIFACT_KEY_PREFIX.length);
    return id ? ROUTES.TOOLS_CONTENT_TEST_DETAIL(id) : null;
  }

  return null;
}
